<div id="data-progressbar">
  <p-progressBar
    mode="indeterminate"
    value="0"
    [style.visibility]="reportParamsService._isFetchingData ? 'visible' : 'hidden'"
  >
  </p-progressBar>
</div>

<div id="inventory-history-report-topWrapper">
  <taku-form-list
    #formListReport
    [_hideViewCol]="true"
    [_model]="_model"
    [_hideSavingCtrls]="true"
    [_showCtrlsInEditMode]="false"
    [_rowSelectionType]="RowSelectionType.NONE"
    _title="Inventory History Report"
    [_hideAddLineHeaderBtn]="true"
    _detailMode="n"
    _scrollHeight="calc(100vh - 18.5rem)"
    [_hideOptionsHeaderBtn]="false"
    [_hideFilterControls]="false"
    [_modelService]="reportCols"
    [_dataService]="inventoryHistoryLocalService"
    [_hideGlobalFilter]="true"
    [_showFooterCurrency]="true"
    [_stateKey]="_stateKey"
  >
  </taku-form-list>
</div>
